import React, { FC, ReactNode } from "react";
import { HeaderHeightProvider } from "../../context/headerHeightContext";
import { FooterHeightProvider } from "../../context/footerHeightContext";
import { MyPriceListProvider } from "../../context/myPriceListContext";
import { SeenProductsProvider } from "../../context/seenProductsContext";
import { SWRConfig } from "swr";
import ClerkWrapper from "../ClerkWrapper";

const TopLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ClerkWrapper>
      <SWRConfig
        value={{
          fetcher: (resource, init) =>
            fetch(resource, init).then((res) => res.json()),
        }}
      >
        <HeaderHeightProvider>
          <FooterHeightProvider>
            <MyPriceListProvider>
              <SeenProductsProvider>{children}</SeenProductsProvider>
            </MyPriceListProvider>
          </FooterHeightProvider>
        </HeaderHeightProvider>
      </SWRConfig>
    </ClerkWrapper>
  );
};

export default TopLayout;
